import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Label,
  FormFeedback,
  Button,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Col,
  ModalFooter,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import OrganizationService from "../../../services/OrderingServices/OrganizationService";

// Validation Schema
const validationSchema = Yup.object({
  name: Yup.string().required("Organization Name is required"),
  orgCode: Yup.string().required("Organization code is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  adminEmail: Yup.string()
    .email("Invalid email")
    .required("Admin Email is required"),

  address1: Yup.string().required("Address is required"),
  contactNo: Yup.string()
    .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
    .required("Phone number is required"),
});

const OrgForm = ({ selectedOrg, modal, toggleModal, fetchOrg }) => {
  console.log("🚀 ~ selectedOrg:", selectedOrg);
  const [orgDetail, setOrgDetail] = useState();

  useEffect(() => {
    const fetchOrgDetail = async () => {
      try {
        const response = await OrganizationService.detail(selectedOrg?.id);
        setOrgDetail(response);
      } catch (error) {}
    };
    fetchOrgDetail();
  }, [selectedOrg?.id]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: orgDetail?.id || "",

      name: orgDetail?.name || "",
      orgCode: orgDetail?.orgCode || "",
      email: orgDetail?.email || "",
      adminEmail: orgDetail?.adminEmail || "",

      address1: orgDetail?.address1 || "",
      contactNo: orgDetail?.contactNo || "",
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        if (values.id) {
          await OrganizationService.update(values.id, values);
          toast.success("Customer updated successfully.");
        } else {
          await OrganizationService.create(values);
          toast.success("New customer is added successfully");
          resetForm();
        }
        fetchOrg();
        toggleModal();
      } catch (error) {
        console.log(error);
        toast.error(error?.response?.data);
      }
    },
  });

  return (
    <Modal isOpen={modal} toggle={toggleModal} backdrop="static" size="lg">
      <ModalHeader toggle={toggleModal}>
        {selectedOrg?.id ? "Update" : "Add"} Organization
      </ModalHeader>
      <Form onSubmit={formik.handleSubmit}>
        <ModalBody>
          <Row>
            <Col>
              <div className="form-floating mb-3">
                <Input
                  id="name"
                  name="name"
                  type="text"
                  className="form-control"
                  placeholder="Enter name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                  invalid={!!(formik.touched.name && formik.errors.name)}
                  style={{ padding: "0.5rem", height: "1rem" }}
                />
                <Label for="name">Org Name</Label>
                {formik.touched.name && formik.errors.name && (
                  <FormFeedback type="invalid">
                    {formik.errors.name}
                  </FormFeedback>
                )}
              </div>
            </Col>
            <Col md={6}>
              <div className="form-floating mb-3">
                <Input
                  id="orgCode"
                  name="orgCode"
                  type="text"
                  className="form-control"
                  placeholder="Enter Organization Code"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.orgCode}
                  invalid={!!(formik.touched.orgCode && formik.errors.orgCode)}
                  style={{ padding: "0.5rem", height: "1rem" }}
                />
                <Label for="orgCode">Organization Code</Label>
                {formik.touched.orgCode && formik.errors.orgCode && (
                  <FormFeedback type="invalid">
                    {formik.errors.orgCode}
                  </FormFeedback>
                )}
              </div>
            </Col>
            <Col md={6}>
              {" "}
              <div className="form-floating mb-3">
                <Input
                  id="adminEmail"
                  name="adminEmail"
                  type="text"
                  className="form-control"
                  placeholder="Enter admin email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.adminEmail}
                  invalid={
                    !!(formik.touched.adminEmail && formik.errors.adminEmail)
                  }
                  style={{ padding: "0.5rem", height: "1rem" }}
                />
                <Label for="adminEmail">Admin Email</Label>
                {formik.touched.adminEmail && formik.errors.adminEmail && (
                  <FormFeedback type="invalid">
                    {formik.errors.adminEmail}
                  </FormFeedback>
                )}
              </div>
            </Col>
            <Col md={6}>
              <div className="form-floating mb-3">
                <Input
                  id="email"
                  name="email"
                  type="email"
                  className="form-control"
                  placeholder="Enter email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  invalid={!!(formik.touched.email && formik.errors.email)}
                  style={{ padding: "0.5rem", height: "1rem" }}
                />
                <Label for="email">Email</Label>
                {formik.touched.email && formik.errors.email && (
                  <FormFeedback type="invalid">
                    {formik.errors.email}
                  </FormFeedback>
                )}
              </div>
            </Col>
            <Col md={6}>
              <div className="form-floating mb-3">
                <Input
                  id="address1"
                  name="address1"
                  type="text"
                  className="form-control"
                  placeholder="Enter address1"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.address1}
                  invalid={
                    !!(formik.touched.address1 && formik.errors.address1)
                  }
                  style={{ padding: "0.5rem", height: "1rem" }}
                />
                <Label for="address1">Address</Label>
                {formik.touched.address1 && formik.errors.address1 && (
                  <FormFeedback type="invalid">
                    {formik.errors.address1}
                  </FormFeedback>
                )}
              </div>
            </Col>
            <Col md={6}>
              <div className="form-floating mb-3">
                <Input
                  id="contactNo"
                  name="contactNo"
                  type="text"
                  className="form-control"
                  placeholder="Enter phone number"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.contactNo}
                  invalid={
                    !!(formik.touched.contactNo && formik.errors.contactNo)
                  }
                  style={{ padding: "0.5rem", height: "1rem" }}
                />
                <Label for="contactNo">Phone Number</Label>
                {formik.touched.contactNo && formik.errors.contactNo && (
                  <FormFeedback type="invalid">
                    {formik.errors.contactNo}
                  </FormFeedback>
                )}
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={toggleModal}>
            Cancel
          </Button>

          <Button color="success" type="submit">
            {selectedOrg?.id ? "Update" : "Create"}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default OrgForm;
